import axios from "axios";
const BaseURL = process.env.REACT_APP_BASE_URL

export const getPrivacyPolicy = () => {
    return new Promise(async (resolve, reject) => {

        try {

            const resp = await axios.get(`${BaseURL}users/policy`,);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })
}

export const getTermsNconditions = () => {
    return new Promise(async (resolve, reject) => {

        try {

            const resp = await axios.get(`${BaseURL}users/terms`,);
            resolve(resp.data)

        } catch (err) {
            reject(err)
        }

    })
}